import { createStyles, Theme, withStyles, WithStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import MuiTableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import React from "react";
import { TableBodyColumnSchema } from "../models";
import { TableCellContent } from "./TableCellContent";

const styles = (theme: Theme) =>
  createStyles({
    tableHeadRow: {
      height: 48,
    },
    tableHeadCell: {
      borderBottomColor: theme.palette.divider,
      color: theme.palette.text.primary,
      fontSize: theme.typography.body2.fontSize,
      "&:first-child": {
        paddingLeft: 0,
      },
      "&:last-child": {
        paddingRight: 0,
      },
    },
    tableRow: {
      "&:last-child td": {
        borderBottom: 0,
      },
    },
    tableCell: {
      color: theme.palette.text.primary,
      fontSize: theme.typography.body2.fontSize,
      "&:first-child": {
        paddingLeft: 0,
      },
      "&:last-child": {
        paddingRight: 0,
      },
    },
  });

interface TableBodyRowTableProps extends WithStyles<typeof styles> {
  parentRowIndex: number;
  columnSchemas: TableBodyColumnSchema[];
  data: any[];
}

export const TableBodyRowTableComponent = (props: TableBodyRowTableProps) => {
  const { columnSchemas, data = [], classes } = props;

  return (
    <Table>
      <TableHead>
        <TableRow className={classes.tableHeadRow}>
          {columnSchemas &&
            columnSchemas.map((columnSchema, cellIndex: number) => (
              <TableCell
                key={`ebc_${cellIndex}`}
                padding={columnSchema.padding}
                size={columnSchema.size}
                align={columnSchema.align}
                className={classes.tableHeadCell}
                style={{ width: columnSchema.width }}
              >
                {columnSchema.label}
              </TableCell>
            ))}
        </TableRow>
      </TableHead>
      <MuiTableBody>
        {data.length > 0 ? (
          data.map((expandedRow: any, rowIndex: number) => {
            return (
              <TableRow hover={true} key={`ebr_${rowIndex}`} className={classes.tableRow}>
                {columnSchemas.map((columnSchema, cellIndex) => (
                  <TableCell
                    key={`ebc_${cellIndex}`}
                    padding={columnSchema.padding}
                    size={columnSchema.size}
                    align={columnSchema.align}
                    className={classes.tableCell}
                    style={{ width: columnSchema.width }}
                  >
                    <TableCellContent
                      columnId={columnSchema.id}
                      rowData={expandedRow}
                      format={columnSchema.format}
                      emptyValue={columnSchema.emptyValue}
                      cellRenderer={columnSchema.cellRenderer}
                    />
                  </TableCell>
                ))}
              </TableRow>
            );
          })
        ) : (
          <TableRow hover={false} tabIndex={-1} className={classes.tableRow}>
            <TableCell colSpan={columnSchemas.length} style={{ textAlign: "center" }}>
              No results to display.
            </TableCell>
          </TableRow>
        )}
      </MuiTableBody>
    </Table>
  );
};

export const TableBodyRowTable = withStyles(styles)(TableBodyRowTableComponent);
